import * as actionTypes from './actionTypes';

export const fetchGrantsDashboardData = payload => ({
  type: actionTypes.dashboardDataFetchType,
  payload
});

export const fetchLazyLoadData = payload => ({
  type: actionTypes.fetchLazyLoadDataType,
  payload
});

export const putChartData = payload => ({
  type: actionTypes.storeChartGrantsDataType,
  payload
});

export const resetChartData = () => ({
  type: actionTypes.disableGrantsShowType
});

export const restoreData = () => ({
  type: actionTypes.resetGrantDataType
});

// search charity

export const charityGrantDashboardSearched = payload => ({
  type: actionTypes.postCharitySearchType,
  payload
});

export const grantCitySearched = payload => ({
  type: actionTypes.postCitySerachType,
  payload
});

export const grantCountySearched = payload => ({
  type: actionTypes.postCountySearchType,
  payload
});

export const grantCityLoader = payload => ({
  type: actionTypes.cityLoaderType,
  payload
});
export const grantCountyLoader = payload => ({
  type: actionTypes.countyLoaderType,
  payload
});

export const fetchAccountDetails = payload => ({
  type: actionTypes.fetchSelectedAccountType,
  payload
});

export const grantSelectCharity = payload => ({
  type: actionTypes.selectCharityType,
  payload
});

export const grantSetScheduleAllocation = payload => ({
  type: actionTypes.makeScheduleAllocationType,
  payload
});

export const grantPostSavedCharity = (payload, successFn) => ({
  type: actionTypes.saveCharityType,
  payload,
  successFn
});

export const fetchPendingGrant = payload => ({
  type: actionTypes.fetchPendGrantType,
  payload
});

export const grantShowGeminiFilter = payload => ({
  type: actionTypes.geminiFilterType,
  payload
});

export const grantUpdateFromCounter = payload => ({
  type: actionTypes.updateFromCounterType,
  payload
});

export const grantUpdateLoadMoreCounter = payload => ({
  type: actionTypes.updateFromLoadingCounterType,
  payload
});

export const grantUpdatefrom = () => ({
  type: actionTypes.updateFromType
});

export const grantEinData = payload => ({
  type: actionTypes.einDataType,
  payload
});

export const grantGeminiEinData = payload => ({
  type: actionTypes.geminiEinDataType,
  payload
});

export const grantSearchTerm = payload => ({
  type: actionTypes.searchTermType,
  payload
});

export const grantGeminiSearchTerm = payload => ({
  type: actionTypes.geminiSearchTermType,
  payload
});


export const grantSearchGemini = payload => ({
  type: actionTypes.searchGeminiType,
  payload
});

export const grantRemoveCharity = (payload, successFn) => ({
  type: actionTypes.removeCharityType,
  payload,
  successFn
});

export const grantFetchSavedCharity = payload => ({
  type: actionTypes.fetchSavedCharityType,
  payload
});

export const grantPostSavedGemini = (payload, successFn) => ({
  type: actionTypes.postGeminiSavedDataType,
  payload,
  successFn
});

export const addCharity = (payload, selectedCharity, successFn) => ({
  type: actionTypes.addCharityType,
  payload,
  selectedCharity,
  successFn
});

export const cancelSaveCharity = (payload) => ({
  type: actionTypes.cancelSaveCharityType,
  payload
});

export const grantsClearAllFilters = (payload) => ({
  type: actionTypes.clearAllFiltersType,
  payload
});

export const grantsClearAllGeminiFilters = (payload) => ({
  type: actionTypes.clearAllGeminiFiltersType,
  payload
});
